import { render, staticRenderFns } from "./privilegeStaffInfo.vue?vue&type=template&id=48d9fa00&scoped=true"
import script from "./privilegeStaffInfo.vue?vue&type=script&lang=js"
export * from "./privilegeStaffInfo.vue?vue&type=script&lang=js"
import style0 from "./privilegeStaffInfo.vue?vue&type=style&index=0&id=48d9fa00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9fa00",
  null
  
)

export default component.exports